<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light">
        <v-row justify="center">
            <v-dialog v-model="uploadDialog" max-width="500px">
                <v-card>
                  <v-card>
                    <v-card-title class="headline pa-0 pa-2">
                    <span>Upload</span>
                    <v-spacer></v-spacer>
                     <v-btn icon @click="uploadDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    </v-card-title>
                  </v-card>
                    <v-card-text class="pt-6">
                        <v-file-input v-model="upload_file" label="Select file" outlined prepend-inner-icon="mdi-paperclip" prepend-icon="" accept=".csv"></v-file-input>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn text color="normal" @click="uploadDialog = false">Cancel</v-btn>
                          <v-btn color="primary" :disabled="!upload_file" @click="submitApprovalFile">Upload</v-btn>
                         <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <div>
          <v-alert
            :type="alert_type"
            :value="alert"
            transition="scale-transition"
            >{{ alert_message }}</v-alert
          >
        </div>
        <div><HeaderComponent :headerTitle="headerText"/></div>
        <v-card-title>
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" label="Search" single-line></v-text-field>
          <v-spacer></v-spacer>
            <v-card-actions >
            <v-flex xs12 d-flex>
              <v-btn color="primary" dense class="mr-4 mt-1" @click="openUploadPopup()">Upload</v-btn>
              <v-icon size="24" @click="handleRefreshClick()" :class="{ 'icon-rotate': isRotating }" color="primary">mdi-refresh</v-icon>
            </v-flex>
          </v-card-actions>
        </v-card-title>
        <v-layout column>
          <v-flex md6 style="overflow: auto">
            <v-data-table
              :dense="true"
              :headers="headers"
              :items="table_data"
              :search="search"
              item-key="id"
              class="elevation-1"
              :loading="loading"
              loading-text="Loading Data... Please wait">
               <template v-slot:item.download="{item}">
                <a :href="item.master_file.url" target="_blank" style="color:#1976D2; font-size:14px">Download</a>
              </template>
              <template v-slot:item.created_at="{ item }">{{ dateTimeform(item.created_at) }}</template>              
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-card>
</template>
<script>
  import HeaderComponent from "../../../../commoncomponents/HeaderComponent";
  export default {
    data () {
      return {
        search: '',
        headerText: 'View Approval Upload List',
        alert: false,
        alert_message: '',
        alert_type: '',
        table_data: [],
        loading: false,
        headers: [
          { text: "ID", value: "id"},
          { text: "File Name", value: "filename"},
          { text: "Upload Date", value: "created_at" },
          { text: "Status", value: "status" },
          { text: "Remarks", value: "remarks" },
         { text: "Download", value: "download" },
        ],
        table_data: [],
        uploadDialog: false,
        upload_file: null,
        isRotating: false,
      }
    },
    created() {
      this.getFileUploadList()
    },
    methods: {
        handleRefreshClick() {
          this.isRotating = true;
          this.getFileUploadList();
          setTimeout(() => {
            this.isRotating = false;
          }, 600);
        },
        alertTimeOut() {
        setTimeout(() => { this.alert = false;}, 3000);
      },
      showAlert(alert_type, alert_message) {
        this.alert         = true;
        this.alert_type    = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      getFileUploadList() {
        this.loading = true
        this.$http.secured.get('/admin/master_file_uploads?file_type=Liquidation Approval')
          .then(response => {
            this.table_data = response.data.master_file_uploads
            this.loading = false
          })
          .catch(error => {
            this.$toast.error('Error in fetching file upload list')
            this.loading = false
          })
      },
      downloadFile(file_url) {
        const link = document.createElement('a')
        link.href = file_url
        link.setAttribute('download', '')
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      openUploadPopup() {
        this.upload_file = null;
        this.uploadDialog = true;
    },
    submitApprovalFile() {
      const formData = new FormData();
      formData.append('user_id', this.$store.state.currentUser.id);
      formData.append('master_file', this.upload_file);
      formData.append('master_file_type', "Liquidation Approval");
      this.$http.secured.post('/admin/master_file_uploads', formData)
        .then(response => {
          if (response.data) {
            this.showAlert("success", "File Uploaded Successfully");
            this.uploadDialog = false;
            this.getFileUploadList();
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    dateTimeform(d){
        var date    = new Date(d)
        var hours   = date.getHours();
        var minutes = date.getMinutes();
        var ampm    = hours >= 12 ? 'PM' : 'AM';
        hours       = hours % 12;
        hours       = hours ? hours : 12; // the hour '0' should be '12'
        minutes     = minutes < 10 ? '0'+minutes : minutes;
        var strTime = date.toLocaleDateString("en-US") + ' ' + hours + ':' + minutes + ' ' + ampm;
        return strTime;
      },
    },
    components: {
      HeaderComponent
    }
  }
</script>
<style scoped>
.icon-rotate {
  animation: rotate 0.6s ease-in-out;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/api/v1/warehouse/liquidation/ViewFileUploadList.vue